import React from 'react';

const Main = () => <h1> Main Page </h1>;

export default Main;
